export enum ANIMATION_STATE {
  IDLE = "idle",
  ENTERING = "entering",
  PULSING_1 = "pulsing_1",
  PULSING_2 = "pulsing_2",
  EXIT = 'exit'
}

const PULSE_DURATION_OUT = 0.5;
const PULSE_DURATION_HOLD = 1.5;
const PULSE_DURATION_IN = 0.5;
const PULSE_DURATION_HOLD_BIG = 0;
const PULSE_CYCLES_ENTERING = 6;

const PULSE_CYCLE_DURATION =
  PULSE_DURATION_HOLD +
  PULSE_DURATION_IN +
  PULSE_DURATION_HOLD_BIG +
  PULSE_DURATION_OUT;

const TOTAL_ENTERING_PULSE_DURATION =
  PULSE_CYCLE_DURATION * PULSE_CYCLES_ENTERING;

export const ANIMATION_CONFIG = {
  ENTER_DURATION: 0.5,
  EXIT_DURATION: 0.4,
  BASE_DELAY: 0.1,
  BONUS_TEXT_Y_SHIFT_OUT: 8,
  PULSE_DURATION_OUT,
  PULSE_DURATION_HOLD,
  PULSE_DURATION_IN,
  PULSE_DURATION_HOLD_BIG,
  PULSE_CYCLES_ENTERING,
  PULSE_CYCLE_DURATION,
  TOTAL_ENTERING_PULSE_DURATION,
};

export const PULSE_CYCLE_COUNT = 2;
export const PULSE_EXIT_DELAY_SECONDS = 1;

export const LOOP_CONFIG = {
  INITIAL_DELAY: 1000,
  RESET_DELAY: 1000,
  PULSE_HOLD_DELAY: 1000,
  COIN_BURST_DELAY: 1000,
};
